import { useOutletContext } from "react-router";

import { BasePage } from "../components/base-page";
import { BatchConfigForm } from "../core/transcription/transcription-config/batch-config-form";
import { TranscriptionOutletContext } from "../types/types";

export function TranscriptionConfigPage() {
  const {
    mediaFile,
    setMediaFile,
    transcriptionConfiguration,
    setTranscriptionConfiguration,
  } = useOutletContext<TranscriptionOutletContext>();

  return (
    <BasePage footer={false}>
      <div className="mx-auto mt-10 h-full w-[750px] max-w-full overflow-auto px-6 py-5">
        <BatchConfigForm
          mediaFile={mediaFile}
          setMediaFile={setMediaFile}
          setTranscriptionConfiguration={setTranscriptionConfiguration}
          transcriptionConfiguration={transcriptionConfiguration}
        />
      </div>
    </BasePage>
  );
}
